import React from 'react';
import CustomTreeView from '../../../../../components/Tree/CustomTreeView';
import ScheduleSelectorDayTime from './../../../../../components/ScheduleSelectorDayTime';
import AccessCardFunctionality from '../Functionality/AccessCardFunctionality';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @param id
 * @param setModified
 * @returns {JSX.Element}
 * @constructor
 */

const WorkShiftAccessCard = ({id, setModified}) => {
    const {
        zoneData,
        fromValue,
        setfromValue,
        toValue,
        setToValue,
        setAllDays,
        allTime,
        setAllTime,
        checked,
        setChecked,
        dayArray,
        setDayArray,
        handleCheck,
        handleCLick,
        emptyFields,
    } = AccessCardFunctionality({
        id,
        setModified
    });

    return (
        <div className='pt-3 row pr-5'>
            <div className='col-lg-6 work_shift_tree_view'>
                <CustomTreeView
                    tittle={'zones'}
                    data={zoneData}
                    checked={checked}
                    onInputchange={handleCheck}
                    isChecked={checked}
                    setChecked={setChecked}
                    className={"h-100"}
                />
            </div>
            <ScheduleSelectorDayTime
                dayArray={dayArray}
                allTime={allTime}
                fromValue={fromValue}
                setfromValue={setfromValue}
                toValue={toValue}
                setToValue={setToValue}
                handleCLick={handleCLick}
                setDayArray={setDayArray}
                setAllDays={setAllDays}
                setAllTime={setAllTime}
                emptyFields={emptyFields}
            />
        </div>
    );
};

export default WorkShiftAccessCard;
